import './Thumbnails.scss';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps extends PropsWithChildren {
  isLoading: boolean;
}

export const Thumbnails = observer((props: IProps): ReactElement => {
  return <div className='thumbnails'>{!props.isLoading && props.children}</div>;
});
